<template>
  <div>
    <div class="about-wrapper">
      <div class="intro-container">
        <div class="intro-item">
          <div class="intro-con">
            <div class="title">关于我们</div>
            <div class="content content-desc">
              <p>浙江禾悦智能科技有限公司是一家致力于面向政府、医院、学校、民族宗教及各类企事业单位提供多渠道服务系统的软件开发、系统集成、自助设备生产运维及服务运营的综合性服务类厂商。</p>
              <p>
                公司拥有丰富的自助服务项目开发经验，，在软件开发过程中严格按照国家和行业信息标准，系统规范来执行，通过科学化、规范化和制度化的管理程序，确保高效高质量地完成整个项目。
              </p>
              <div class="box">
                <div class="box-item">
                  <div class="box-con">
                    <div class="box-title">赢得尊敬</div>
                    <div class="box-subtitle">企业愿景</div>
                    <div class="box-desc">不断倾听和满足用户需求，引导并超越用户需求，赢得用户尊敬；通过提升企业地位与品牌形象，使员工具有高度的企业荣誉感和自豪感，赢得员工尊敬；推动互联网行业的健康发展，与合作伙伴共同成长，赢得行业尊敬；注重企业责任，关爱社会、回馈社会，赢得社会尊敬。
                    </div>
                  </div>
                </div>
                <div class="box-item">
                  <div class="box-con">
                    <div class="box-title">提升人类生活品质</div>
                    <div class="box-subtitle">企业使命
                    </div>
                    <div class="box-desc">使产品和服务像水和电一样源源不断融入人们的生活，为人们带来便捷和愉悦；关注不同地域、不同群体，并针对不同对象提供差异化的产品和服务；打造开放共赢平台，与合作伙伴共同营造健康的互联网生态环境。</div>
                  </div>
                </div>
                <div class="box-item">
                  <div class="box-con">
                    <div class="box-title">一切以用户价值为依归</div>
                    <div class="box-subtitle">经营理念</div>
                    <div class="box-desc">注重长远发展，不因商业利益伤害用户价值；关注并深刻理解用户需求，不断以卓越的产品和服务满足用户需求；重视与用户的情感沟通，尊重用户感受，与用户共成长。</div>
                  </div>
                </div>
                <div class="box-item">
                  <div class="box-con">
                    <div class="box-title">正直，进取，合作，创新</div>
                    <div class="box-subtitle">企业价值观</div>
                    <div class="box-desc">遵守国家法律与公司制度，绝不触犯企业高压线；做人德为先，坚持公正、诚实、守信等为人处事的重要原则；尽职尽责，高效执行；具有开放共赢心态，与合作伙伴共享行业成长；创新的目的是为用户创造价值；</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="cert-wrapper">
      <div class="intro-container">
        <div class="intro-item">
          <div class="intro-con">
            <div class="title">研发实力</div>
            <div class="content content-image">
              <div class="image-item">
                <img src="../../assets/images/cert1.png"/>
                <div class="name">智慧医疗自助服务系统软件V1.0著作权</div>
              </div>
              <div class="image-item">
                <img src="../../assets/images/cert2.png"/>
                <div class="name">多功能自助服务系统软件V1.0著作权</div>
              </div>
              <div class="image-item">
                <img src="../../assets/images/cert3.png"/>
                <div class="name">统一支付及对账云平台软件V1.0著作权</div>
              </div>
              <div class="image-item">
                <img src="../../assets/images/cert4.png"/>
                <div class="name">智慧民生自助服务系统软件V1.0著作权</div>
              </div>
              <div class="image-item">
                <img src="../../assets/images/cert5.png"/>
                <div class="name">住房线上贷系统V1.0软件著作权</div>
              </div>
              <div class="image-item">
                <img src="../../assets/images/cert6.png"/>
                <div class="name">智慧场所管理云平台V1.0软件著作权</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'about'
}
</script>

<style scoped lang="less">
  @import "../../assets/css/variable";
  .about-wrapper {
    // background: @bg-color-grey;
    // margin-bottom: -@spacing-col-lg - @spacing-col-lg;
  }
  .cert-wrapper {
    background: @bg-color-grey;
    // margin-bottom: -@spacing-col-lg - @spacing-col-lg;
  }
</style>



// WEBPACK FOOTER //
// src/pages/about/about.vue